export default "__VITE_ASSET__GzTDdHq3__"